import type { SVGProps } from "react";

export function Handshake(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 12l4-4 4 4" />
      <path d="M20 12l-4-4-4 4" />
      <path d="M8 12l2 2" />
      <path d="M12 12l2 2" />
      <path d="M6 8h2l1 1" />
      <path d="M16 8h2l-1 1" />
    </svg>
  );
}
